import React from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { resetpwdValidation } from './Validation';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { confirmpasswordeye, passwordeye, popUp, updatePassword } from '../Redux/Auth/AuthSlice';
import { jwtDecode } from "jwt-decode";
import { Notify } from '../CommonPopup/Popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Spinner from '../Spinner/Spinner';



const schema = resetpwdValidation

const ResetPwd = () => {
    const config = 'jhdgsjhcbjsdklcbjksnckbskdnskjncjksdbchnsdkcjb'
    const selector = useSelector((s) => s.AuthSlice)
    const showconfirmpassword = selector.showconfirmpassword
    const showpassword = selector.showpassword
    const loader = selector.loader


    const { token } = useParams();
    const id = jwtDecode(token);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = (data) => {
        console.log("reset data", data);
        reset()
        dispatch(updatePassword({ id: id, data: data.password })).then((data) => {
            if (data.payload.success === true) {
                Notify({ data: "success", msg: data.payload.message })
                navigate("/")

            } else {
                Notify({ data: "error", msg: data.payload.message })
            }

            setTimeout(() => {
                dispatch(popUp(false))

            }, 5000);
        })


    };

    return (
        <div>
            <div className='container mt-5 '>
                <h2 className='fw-bold'>Reset Password</h2>
                {loader ? <Spinner /> : <form onSubmit={handleSubmit(onSubmit)} className=' form-group shadow shadow-lg w-25 m-auto p-4 py-4 mt-4'>


                    <Controller
                        name="password"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                label="New Password"
                                type={showpassword ? "type" : "password"}
                                className="my-3 form-group"
                                fullWidth
                                variant="outlined"
                                error={!!errors.password}
                                helperText={errors.password?.message}
                                {...field}
                            />
                        )}
                    />
                    <FontAwesomeIcon onClick={() => { dispatch(passwordeye(!showpassword)) }} className='resetpasswordeye text-dark' icon={showpassword ? faEye : faEyeSlash} />


                    <Controller
                        name="confirmPassword"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                label="Confirm Password"
                                className='form-group'
                                type={showconfirmpassword ? "type" : "password"}
                                fullWidth
                                variant="outlined"
                                error={!!errors.confirmPassword}
                                helperText={errors.confirmPassword?.message}
                                {...field}
                            />
                        )}
                    />
                    <FontAwesomeIcon onClick={() => { dispatch(confirmpasswordeye(!showconfirmpassword)) }} className='resetconfirmpasswordeye text-dark' icon={showconfirmpassword ? faEye : faEyeSlash} />

                    <Button className='mt-3' type="submit" variant="contained" color="primary">
                        Reset Password
                    </Button>

                </form>}

            </div>
        </div>
    )
}

export default ResetPwd
